import { render, staticRenderFns } from "./TemplateDataHeader.vue?vue&type=template&id=10b4e3a6&"
import script from "./TemplateDataHeader.vue?vue&type=script&lang=js&"
export * from "./TemplateDataHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports